import AuthGuard from "@/components/AuthGuard";
import { PATH_PERMISSION_DENIED } from "@/constants";
import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { StructureAssignmentsPermissions } from "@/modules/structure-assignments/permissions/structureAssignmentsPermissions";
import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { PropsWithChildren } from "react";
import { Navigate, useParams } from "react-router-dom";

function hasPermissionForAssignmentType(
  permissions: StructureAssignmentsPermissions,
  assignmentType: string | undefined,
): boolean {
  switch (assignmentType) {
    case ASSIGNMENT_TYPES.RR_2_RD:
      return permissions.structure_assignments_rr_to_rd_read;
    case ASSIGNMENT_TYPES.RR_2_FAM:
      return permissions.structure_assignments_rr_to_fam_read;
    case ASSIGNMENT_TYPES.KAM_2_CSD:
      return permissions.structure_assignments_kam_to_csd_read;
    default:
      return false;
  }
}

export default function StructureAssignmentsRouteGuard({
  children,
}: PropsWithChildren) {
  const { assignmentType } = useParams<{ assignmentType: string }>();
  const permissions = useModulePermissions(Module.StructureAssignments);
  const hasPermission = hasPermissionForAssignmentType(
    permissions,
    assignmentType,
  );

  return (
    <AuthGuard>
      {hasPermission ? (
        children
      ) : (
        <Navigate to={PATH_PERMISSION_DENIED} replace />
      )}
    </AuthGuard>
  );
}
